import { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp,faDownload } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';

const Body = ({sectionallresources,sectionVideo,sectionFacilitator,hours,setTraintimeslot,udateCompindex}) => {
    const { t, i18n } = useTranslation();
    const set_class_name = (type) =>{
       
        if(type == 1){
            return 'facilitator';
        }

        if(type == 2){
            return 'videos';
        }
       
        if(type == 3){
            return 'break';
        }
    };
    const set_class_time = (type) =>{
       
        if(type == 1){
            return 'd-flex align-items-center facilitator-time';
        }

        if(type == 2){
            return 'd-flex align-items-center videos-time';
        }
       
        if(type == 3){
            return 'd-flex align-items-center break-time';
        }
    };
  //  let items = hours;
    let [items, setState] = useState(
        hours
      );

      let [activeclass, setActive] = useState(
        0
      );

   const  toggleItem = (myindex) => {
    let i_lenght = hours.length;

    for (let i = 0; i < i_lenght; i++) {
           if(myindex+1 == i){
               hours[i].defult = true;
           }
           else if(myindex == i){
               hours[i].defult = true;
           }else{
               hours[i].defult = false;
           }
       }
       let items_other = hours;
       
        setState(prevItems =>
            prevItems.map((item,index) =>{
                
                return { ...item, default: myindex === index }; 
            }
            ));
            setActive(myindex);
    }
    const [activearrowUp, setArroState] = useState(
        "arrowup"
      ); 
    const toggleItemAll = () => {
        let i_lenght = hours.length;
        if(activearrowUp == 'arrowup'){
        for (let i = 0; i < i_lenght; i++) {   
                hours[i].defult = true;
        }
    }else{
        for (let i = 0; i < i_lenght; i++) {  
            if(i < 2){ 
            hours[i].defult = true;
            }else{
                hours[i].defult = false;
            }
        }
    }
        let items_other = hours;
          
         setState(prevItems =>
             prevItems.map((item,index) =>{
                 
                 return { ...item, default: true }; 
             }
             ));
        setActive(0);
        if(activearrowUp == 'arrowup'){
            setArroState('arrowdown');
        }else{
            setArroState('arrowup');
        }
    }
  const show_facilator = (item,description) => {
    let max = 100;
    let min = 1;
    udateCompindex(Math.floor(Math.random() * (max - min + 1)) + min);
    sessionStorage.setItem('fac_item_data', JSON.stringify(item));
    sessionStorage.setItem('fac_item_desctiption', JSON.stringify(description));
  }

   const show_video = (item,description) => {
    let max = 100;
    let min = 1;
    udateCompindex(Math.floor(Math.random() * (max - min + 1)) + min);
    sessionStorage.setItem('video_item_data', JSON.stringify(item));
    sessionStorage.setItem('video_item_desctiption', JSON.stringify(description));
  }
  

  return (
    <section className="session-hourly-setup">
    <div className="container">
        <div className="inner-content-wrapper d-flex justify-content-between">
            <div className="session-hour-content">
            {hours.map((item, index) => (
                 
                <div key={index} className={item.defult ? 'hour-card-items hour-card-active' : 'hour-card-items d-none'}>
                    <div className="hour-content-card">
                        <div className="card-heading d-flex justify-content-between align-items-center">
                            <div className="heading-content">
                                <h4>{item.title}</h4>
                            </div>
                            <div className="card-time">
                                <p>{item.start_time} - {item.end_time}</p>
                            </div>
                        </div>
                    </div>
                    <div className="hour-sessoion-info">
                    {item.description.map((description, index) => (
                        <div key={index} className="inner-wrapper d-flex justify-content-between align-items-center">
                            <div className="session-author">
                                <Link href="#" className={set_class_name(description.type_flag)}>{description.type}</Link>
                            </div>
                            <div className="session-content">
                                <h3>{description.title}</h3>
                                <p className={set_class_time(description.type_flag)}><span><img src="img/clock-icon.svg" alt=""/></span>{description.duration}</p>
                            </div>
                            <div className="session-dwn-btn">
                            {description.type_flag == 1 ? <a href={description.documentUrl} className="active-btn"><div><FontAwesomeIcon icon={faDownload} /></div><span>{t("download")}</span> </a> : ''}

                             {description.type_flag == 1 ? (<Link href="#" onClick={() => show_facilator(item,description)} data-bs-toggle="modal" data-bs-target="#facilatatorModal"><div><FontAwesomeIcon icon={faArrowUp} /></div><span>{t("open")}</span></Link>) 
                             :description.type_flag == 2 ? (<Link href="#"  onClick={() => show_video(item,description)} data-bs-toggle="modal" data-bs-target="#videoModal"><div><FontAwesomeIcon icon={faArrowUp} /></div><span>{t("open")}</span></Link>) : ('') }  
                                
                            </div>
                        </div>
                    ))}

                     
                    
                    </div>
                </div>
                ))}
             
                <div className="more-items-btn d-flex justify-content-center">
                    <span onClick={toggleItemAll}><span><img className={activearrowUp} src="img/arrow-white.svg" alt=""/></span></span>
                </div>
            </div>
            <div className="session-content-tab">
                <div className="tabs-content">
                    <h3>{t("Seminar_Contents")}</h3>
                    <ul className="hour-horizental-content">
                    {hours.map((item, index) => (
                        <li key={index}><span onClick= {() => toggleItem(index)} className={index == activeclass ? 'active-tab' : ''}>{item.title}</span></li>
                    ))}
                    </ul>
                    <div className="others-section-tab">
                        <ul>
                            <li><Link href="#" onClick={sectionFacilitator}>{t("All_Facilitators_Guides")}</Link></li>
                            <li><Link href="#" onClick={sectionVideo}>{t("All_Training_Videos")}</Link></li>
                          
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
  );
};

export default Body;